import React, { useState } from 'react'

import { Button, Space } from 'antd'
import { Switch } from '.'

/**
 * A group of Switches
 * @param {string[]} [defaultValue=[]] Default selected value
 * @param {boolean} [disabled=false] If disable all switches
 * @param {string} [name] The name property of all switch children
 * @param {function(checkedValue)} [onChange] The callback function that is triggered when the state changes
 * @param {string[] | Option[]} [options=[]] Specifies options
 * @param {string[]} [value=[]] Used for setting the currently selected value
 * @param {boolean | Position[]} [selectAll=false] Used for showing or hiding the selectAll button
 */
export default function SwitchGroup({ defaultValue, disabled, name, onChange, options, value, selectAll }) {
  const initialCheckedList = []

  const allProps = options.map(option => {
    const props = {}
    if (typeof option === 'string' || option instanceof String) {
      props.label = option
      props.value = option
    } else {
      if (option.label) {
        props.label = option.label
      }
      props.value = option.value ? option.value : props.label
      props.disabled = disabled ? disabled : option.disabled
    }

    if (Array.isArray(defaultValue) && defaultValue.includes(props.value)) {
      props.defaultChecked = true
      props.checked = true
    }
    if (Array.isArray(value) && value.includes(props.value)) {
      props.checked = true
    }

    if (props.defaultChecked || props.checked) {
      initialCheckedList.push(props.value)
    }

    if (name) {
      props.name = name
    }
    return props
  })

  const [switchProps, setSwitchProps] = useState(allProps)

  function onChangeWrapper(value) {
    return (checked) => {
      const allChecked = []
      const newSwitchProps = switchProps.map(props => {
        if (props.value === value) {
          props.checked = checked
        }

        if (props.checked) {
          allChecked.push(props.value)
        }

        return props
      })

      setSwitchProps(newSwitchProps)

      if (onChange) {
        onChange(allChecked)
      }
    }
  }

  function selectAllOnClick() {
    const allChecked = []
    const newProps = switchProps.map(props => {
      props.checked = true
      allChecked.push(props.value)
      return props
    })
    setSwitchProps(newProps)

    if (onChange) {
      onChange(allChecked)
    }
  }

  const switches = <Space size='middle'>{switchProps.map(props => {
    if (props.defaultChecked) {
      return <Switch
        name={props.name}
        text={props.label}
        key={props.value}
        defaultChecked
        checked={props.checked}
        disabled={props.disabled}
        onChange={onChangeWrapper(props.value)}
      />
    } else {
      return <Switch
        name={props.name}
        text={props.label}
        key={props.value}
        checked={props.checked}
        disabled={props.disabled}
        onChange={onChangeWrapper(props.value)}
      />
    }
  })}</Space>

  let top = <></>
  if (selectAll && selectAll.position) {
    // TODO Check for top values
  }

  let bottom = <></>
  if (selectAll) {
    if (selectAll.position) {
      // TODO Check for bottom values
    } else {
      bottom = <Button onClick={selectAllOnClick}>Select All</Button>
    }
  }

  return <Space direction='vertical'>
    {top}
    {switches}
    {bottom}
  </Space>
}
